


































import ChannelInterface from "@/interfaces/channel.interface";
import ContactInterface from "@/interfaces/contact.interface";
import { AppDataEnabledFeatureNames } from "@/types/appDataEnabledFeatures.type";
import { resolvePlatformIcon } from "@/utils/channels";
import { canStartChat } from "@/utils/chats";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import { BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import { useApps } from "@/composables/useApps";

export default defineComponent({
    components: { BDropdownItem, BDropdown },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        buttonAttributes: {
            type: Object,
            required: false,
        },
        channels: {
            type: Array as PropType<ChannelInterface[]>,
            required: true,
        },
        contact: {
            type: Object as PropType<ContactInterface>,
            required: true,
        },
    },
    setup() {
        const { getEnabledFeature } = useApps();

        const clickablePhoneNumbersFeature = computed(() =>
            getEnabledFeature(AppDataEnabledFeatureNames.CLICKABLE_PHONE_NUMBERS)
        );
        const resolveTooltipContent = (channel: ChannelInterface, contact: ContactInterface) => {
            if (channel.platform === "email" && !contact.email) {
                return "entities.contact.no-email";
            }

            if (channel.platform === "whatsapp" && !contact.phone) {
                return "entities.contact.no-phone";
            }
        };

        const getParsedHref = (hrefPattern: string, number: string) => hrefPattern.replaceAll("{number}", number);

        return {
            clickablePhoneNumbersFeature,
            getParsedHref,
            resolvePlatformIcon,
            resolveTooltipContent,
            canStartChat,
        };
    },
});
